// extracted by mini-css-extract-plugin
export default {"link":"styles_link__OC6HM","formGroup":"styles_formGroup__whwA7","childEntriesContainer":"styles_childEntriesContainer__jv5Mk","totalInput":"styles_totalInput__75Qzc"};